import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import { clearSignupSuccess } from "../../reduxStore/reducers/userReducersHelper";
import styles from "./asset/confirmationForm.module.scss";
import { Link } from "react-router-dom";

const ConfirmationFormComponent = () => {
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const [confirmationStatus, setConfirmationStatus] = useState('loading'); // 'loading', 'success', 'error'
    const [userEmail, setUserEmail] = useState('');

    useEffect(() => {
        // Parse URL parameters to extract Supabase tokens (both query params and hash params)
        const parseSupabaseResponse = () => {
            // First try to get query parameters (new Supabase format)
            const urlParams = new URLSearchParams(window.location.search);

            // Then try hash parameters (fallback for old format)
            const hash = window.location.hash.substring(1);
            const hashParams = new URLSearchParams(hash);
            console.log('Hash params:', Object.fromEntries(hashParams));

            // Try query params first, then hash params
            let token = urlParams.get('token') || hashParams.get('access_token');
            let type = urlParams.get('type') || hashParams.get('type');

            // Check if this is a signup confirmation
            if (token && token !== '' && type === 'signup') {
                try {
                    // For the new Supabase format, the token might be a simple verification token
                    // For JWT tokens, try to decode them
                    if (token.includes('.')) {
                        // This is a JWT token
                        const payload = JSON.parse(atob(token.split('.')[1]));
                        setUserEmail(payload.email || '');
                    } else {
                        // This is a simple verification token - we can't extract email from it
                        setUserEmail(''); // Email will be empty for simple tokens
                    }

                    setConfirmationStatus('success');

                    // Clear the URL parameters for security
                    setTimeout(() => {
                        window.history.replaceState(null, null, window.location.pathname);
                    }, 1000);
                } catch (error) {
                    console.error('Error parsing token:', error);
                    // Even if we can't parse the token, if type=signup, consider it success
                    if (type === 'signup') {
                        setConfirmationStatus('success');
                        setUserEmail('');
                    } else {
                        setConfirmationStatus('error');
                    }
                }
            } else {
                // Invalid or missing tokens
                console.log('Invalid tokens or missing required parameters');
                console.log('Available params:', {
                    queryParams: Object.fromEntries(urlParams),
                    hashParams: Object.fromEntries(hashParams)
                });
                setConfirmationStatus('error');
            }
        };

        parseSupabaseResponse();
    }, []);

    const handleGoToSignIn = () => {
        dispatch(clearSignupSuccess());

        navigate("/sign-in");
    };

    const renderContent = () => {
        switch (confirmationStatus) {
            case 'loading':
                return (
                    <div className={styles.confirmationContainer}>
                        <div className={styles.loadingTitle}>Confirming your account...</div>
                        <div className={styles.loadingSpinner}>
                            <div className={styles.spinner}></div>
                        </div>
                        <div className={styles.loadingMessage}>
                            Please wait while we verify your email confirmation.
                        </div>
                    </div>
                );

            case 'success':
                return (
                    <div className={styles.confirmationContainer}>
                        <div className={styles.successIcon}>✅</div>
                        <div className={styles.successTitle}>Email Confirmed!</div>
                        <div className={styles.successMessage}>
                            {userEmail && (
                                <>
                                    Your email <span className={styles.emailHighlight}>{userEmail}</span> has been successfully verified.
                                    <br /><br />
                                </>
                            )}
                            Your account creation has been confirmed and you can now sign in to access your Prepal account.
                        </div>
                        <button
                            className={styles.signInButton}
                            onClick={handleGoToSignIn}
                        >
                            <div className={styles.signInButtonText}>Go to Sign In</div>
                        </button>
                        <div className={styles.helpText}>
                            Ready to start your SAT preparation journey with Prepal!
                        </div>
                    </div>
                );

            case 'error':
                return (
                    <div className={styles.confirmationContainer}>
                        <div className={styles.errorIcon}>❌</div>
                        <div className={styles.errorTitle}>Confirmation Failed</div>
                        <div className={styles.errorMessage}>
                            We couldn't verify your email confirmation. This might happen if:
                            <br /><br />
                            • The confirmation link has expired
                            <br />
                            • The link has already been used
                            <br />
                            • There was an issue with the verification process
                            <br /><br />
                            Please try signing up again or contact support if the problem persists.
                        </div>
                        <button
                            className={styles.signUpButton}
                            onClick={() => navigate("/sign-up")}
                        >
                            <div className={styles.signUpButtonText}>Back to Sign Up</div>
                        </button>
                        <Link to="/sign-in" className={styles.signInLink}>
                            Or try signing in if you already have an account
                        </Link>
                    </div>
                );

            default:
                return null;
        }
    };

    return (
        <div className={styles.confirmationForm}>
            <div className={styles.confirmationChild}>
                <div className={styles.aceYourTestContainer}>
                    <p className={styles.aceYourTest}>Ace your test</p>
                    <p className={styles.aceYourTest}>with Prepal</p>
                </div>
                <img
                    className={styles.maskGroupIcon}
                    alt=""
                    src={require("../../publicAsset/media/book 1.svg").default}
                />
            </div>
            <div className={styles.prepalLogo3Parent}>
                <img
                    className={styles.prepalLogo3}
                    alt=""
                    src={require("../../publicAsset/media/Prepal Logo 3.svg").default}
                />
                <div className={styles.frameParent}>
                    <div className={styles.confirmationWrapper}>
                        <div className={styles.confirmationTitle}>Account Confirmation</div>
                    </div>
                    {renderContent()}
                </div>
            </div>
        </div>
    );
};

export default ConfirmationFormComponent;